export const relatedTitles = [
  {
    id: "rel-01",
    title: "老街的春天",
    genre: "都市情感 · 12集",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20old%20Korean%20street%20market%20in%20soft%20spring%20light%2C%20two%20women%20walking%20with%20paper%20bags%2C%20warm%20orange%20tones%2C%20gentle%20nostalgic%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=fm4-rel-01&orientation=portrait",
    summary: "同一条老街上的另一群邻居，关于和解与重新开始的日常故事。",
    badge: "同类题材",
  },
  {
    id: "rel-02",
    title: "她的第二个名字",
    genre: "女性成长 · 16集",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20woman%20in%20her%20forties%20standing%20in%20front%20of%20a%20mirror%20in%20a%20warm%20dim%20bedroom%2C%20single%20amber%20lamp%2C%20reflective%20melancholic%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=fm4-rel-02&orientation=portrait",
    summary: "中年之后重新选择人生的女性群像，细腻克制的叙事节奏。",
    badge: "观众推荐",
  },
  {
    id: "rel-03",
    title: "楼上的灯",
    genre: "邻里悬疑 · 10集",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20single%20lit%20window%20on%20the%20upper%20floor%20of%20a%20dark%20old%20apartment%20building%20at%20night%2C%20warm%20orange%20glow%20against%20deep%20blue%20darkness%2C%20mysterious%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=fm4-rel-03&orientation=portrait",
    summary: "一栋楼里七户人家，每个人都在隐瞒一件小事。",
    badge: "悬疑向",
  },
  {
    id: "rel-04",
    title: "画不完的窗",
    genre: "治愈剧情 · 8集",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20unfinished%20oil%20painting%20of%20a%20window%20on%20a%20wooden%20easel%2C%20paint%20palette%20and%20brushes%2C%20warm%20studio%20light%2C%20soft%20dusty%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=fm4-rel-04&orientation=portrait",
    summary: "以绘画为线索的短剧，讲述一段被时间搁置的友情。",
    badge: "治愈向",
  },
];